<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4></h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <form>
    <div class="form-group" [formGroup]="form">
      <label>Minimum Work Party Size</label>
      <input type="number" class="form-control" min="1" max="30" formControlName="minPartySize"/>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onSubmit()" [disabled]="!form.valid || !form.dirty" class="btn btn-sm btn-success">Save</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
